import fetch from '../utils/fetch'

//获取密码类型
export function getPwdType() {
  return fetch({
    method:'GET',
    url:'smartlock/getPwdType'
  })
}

//获取密码状态
export function getPwdStatus() {
  return fetch({
    method:'GET',
    url:'smartlock/getPwdStatus'
  })
}


//获取使用人类型
export function getUserType() {
  return fetch({
    method:'GET',
    url:'smartlock/getUserType',
  })
}

//获取密码记录列表
export function getPwdLogList(params) {
  return fetch({
    method:'GET',
    url:'smartlock/getPwdLogList',
    params
  })
}

